'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# PracticeLibrarySVG
An SVG Practice Library icon
 */
var PracticeLibrarySVG = function PracticeLibrarySVG(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'Practice Library',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 75 75',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        fill: color,
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M39.375,0 L31.875,0 C28.77375,0 26.25,2.52375 26.25,5.625 L26.25,7.8225 C25.66125,7.6125 25.03125,7.5 24.375,7.5 L5.625,7.5 C2.52375,7.5 0,10.02375 0,13.125 L0,69.375 C0,72.47625 2.52375,75 5.625,75 L24.375,75 C25.815,75 27.1275,74.45625 28.125,73.56375 C29.1225,74.45625 30.435,75 31.875,75 L39.375,75 C42.47625,75 45,72.47625 45,69.375 L45,5.625 C45,2.52375 42.47625,0 39.375,0 Z M24.375,71.25 L5.625,71.25 C4.59,71.25 3.75,70.41 3.75,69.375 L3.75,13.125 C3.75,12.09 4.59,11.25 5.625,11.25 L24.375,11.25 C25.41,11.25 26.25,12.09 26.25,13.125 L26.25,69.375 C26.25,70.41 25.41,71.25 24.375,71.25 Z M41.25,69.375 C41.25,70.41 40.41,71.25 39.375,71.25 L31.875,71.25 C30.84,71.25 30,70.41 30,69.375 L30,5.625 C30,4.59 30.84,3.75 31.875,3.75 L39.375,3.75 C40.41,3.75 41.25,4.59 41.25,5.625 L41.25,69.375 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M20.625,22.5 L9.90375,22.5 C8.86875,22.5 8.02875,21.66 8.02875,20.625 C8.02875,19.59 8.86875,18.75 9.90375,18.75 L20.625,18.75 C21.66,18.75 22.5,19.59 22.5,20.625 C22.5,21.66 21.66,22.5 20.625,22.5 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M69.7875,73.58625 L58.62,74.95875 C55.54125,75.3375 52.72875,73.14 52.35,70.06125 L45.0375,10.5075 C44.65875,7.42875 46.85625,4.61625 49.935,4.2375 L61.1025,2.865 C64.18125,2.48625 66.99375,4.68375 67.3725,7.7625 L74.685,67.31625 C75.06375,70.395 72.86625,73.2075 69.7875,73.58625 Z M50.39625,7.96125 C49.36875,8.08875 48.6375,9.02625 48.765,10.05 L56.0775,69.60375 C56.205,70.63125 57.1425,71.3625 58.16625,71.235 L69.33375,69.8625 C70.36125,69.735 71.0925,68.7975 70.965,67.77375 L63.6525,8.22 C63.525,7.1925 62.5875,6.46125 61.56375,6.58875 L50.39625,7.96125 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M59.2125,18.21375 L55.48875,18.67125 C54.46125,18.79875 53.52375,18.0675 53.4,17.04 C53.27625,16.0125 54.00375,15.075 55.03125,14.95125 L58.755,14.49375 C59.7825,14.36625 60.72,15.0975 60.84375,16.125 C60.9675,17.1525 60.24,18.09 59.2125,18.21375 Z'
      })
    )
  );
};

PracticeLibrarySVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

PracticeLibrarySVG.displayName = 'PracticeLibrarySVG';

exports.default = PracticeLibrarySVG;
PracticeLibrarySVG.__docgenInfo = {
  'description': '# PracticeLibrarySVG\r\nAn SVG Practice Library icon',
  'methods': [],
  'displayName': 'PracticeLibrarySVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};